<template>
  <div class="row">
    <div class="col-12">
      <card
        v-if="permisosProspectos.acceder"
        card-body-classes="table-full-width"
        no-footer-line
      >
        <h4 slot="header" class="card-title text-purple">
          {{ $t("app.modules.candidates.title") }}
        </h4>
        <div class="col-md-12">
          <div class="row">
            <div :class="sizes">
              {{ $t("app.modules.candidates.headers.date_assignment") }}
              <el-date-picker
                v-model="dates_asign"
                type="daterange"
                align="right"
                @change="changeDateAssi"
                :start-placeholder="$t('app.general.start_date')"
                :end-placeholder="$t('app.general.end_date')"
              >
              </el-date-picker>
            </div>
            <div :class="sizes">
              {{ $t("app.modules.candidates.headers.application_date") }}
              <el-date-picker
                v-model="dates_aplicat"
                type="daterange"
                align="right"
                @change="changeDateApplic"
                :start-placeholder="$t('app.general.start_date')"
                :end-placeholder="$t('app.general.end_date')"
              >
              </el-date-picker>
            </div>
            <div :class="sizes">
              {{ $t("app.general.search") }}
              <fg-input>
                <el-input
                  type="search"
                  clearable
                  prefix-icon="el-icon-search "
                  style="width: 300px"
                  :placeholder="$t('app.general.search')"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </fg-input>
            </div>
          </div>
          <el-table
            stripe
            style="width: 100%;"
            :data="queriedData"
            @filter-change="changeFilters"
          >
            <el-table-column
              prop="nombreContacto"
              :label="this.$t('app.modules.candidates.headers.applicants_name')"
              sortable
              min-width="300"
            >
            </el-table-column>
            <el-table-column
              prop="compañia"
              :label="this.$t('app.modules.candidates.headers.company')"
              sortable
              min-width="200"
            >
            </el-table-column>

            <el-table-column
              prop="estadoProspecto"
              :label="this.$t('app.modules.candidates.headers.status')"
              sortable
              min-width="200"
              :filters="this.estadoProspecto"
              :filter-method="filterStatus"
              filter-placement="bottom-end"
            >
            </el-table-column>

            <el-table-column
              :label="this.$t('app.modules.candidates.headers.date_assignment')"
              min-width="250"
              prop="fechaAsignacion"
            >
            </el-table-column>
            <el-table-column
              :label="
                $t('app.modules.candidates.headers.sales_executive_assigned')
              "
              min-width="250"
              :filters="this.userFilters"
              :filter-method="filterTag"
              filter-placement="bottom-end"
              prop="nombre"
            >
            </el-table-column>
            <el-table-column
              prop="fechaEnvio"
              :label="
                this.$t('app.modules.candidates.headers.application_date')
              "
              sortable
              min-width="250"
            >
            </el-table-column>
            <el-table-column
              min-width="135"
              fixed="right"
              :label="$t('app.general.actions')"
            >
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        v-if="permisosProspectos.detalles"
                        @click.native="
                          EditItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{
                          $t("app.modules.candidates.headers.details_candidate")
                        }}
                      </n-button>
                    </div>
                    <div class="col-12 options">
                      <n-button
                        v-if="
                          props.row.prospectoStatus < 3 &&
                            permisosProspectos.asignar
                        "
                        @click.native="
                          AssignItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        size="sm"
                        class="options-button"
                        round
                      >
                        {{
                          $t("app.modules.candidates.headers.assign_candidate")
                        }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>
      </card>
      <prospectos-detalles />
      <prospectos-asignar />
    </div>
  </div>
</template>

<script>
import Fuse from "fuse.js";
import { mapState } from "vuex";

export default {
  components: {
    ProspectosDetalles: () => import("./prospectosDetalles"),
    ProspectosAsignar: () => import("./prospectosAsignar")
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      this.generalFilter();
    },
    assignDate(value) {
      this.generalFilter();
    },
    applicateDate(value) {
      this.generalFilter();
    }
  },
  computed: {
    ...mapState(["modules"]),
    queriedData() {
      let result = this.tableData;
      result = this.searchedData;
      /*if (this.searchedData.length > 0) {
        result = this.searchedData;
      }*/
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      permisosProspectos: {
        acceder: false,
        detalles: false,
        asignar: false,
        aceptar: false,
        rechazar: false
      },
      dates_aplicat: "",
      dates_asign: "",
      estadoProspecto: [
        { text: "Pendiente de Asignar", value: "Pendiente de Asignar" },
        { text: "Asignado", value: "Asignado" },
        { text: "Aprobado", value: "Aprobado" },
        { text: "Rechazado", value: "Rechazado" }
      ],
      sizes: "col-md-3 col-sm-6",
      typeSelected: 0,
      statusSelected: "",
      assignDate: "",
      applicateDate: "",
      datePickerModal: false,
      searchQuery: "",
      searchedData: [],
      userFilters: [],
      statusFilters: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      tableData: [],
      fuseSearch: null
    };
  },
  async created() {
    await this.revisarPermisos();
  },
  async mounted() {
    const options = {
      keys: ["compañia", "nombreContacto", "fechaEnvio", "fechaAsignacion"]
    };
    this.fuseSearch = new Fuse(this.tableData, options);
    EventBus.$on("reload-items", () => {
      this.getItems();
      this.generalFilter();
    });
  },
  methods: {
    async revisarPermisos() {
      var permisos = [];
      for (var i = 0; i < this.modules.length; i++) {
        if (this.modules[i].nombreModulo === "Prospectos") {
          permisos = this.modules[i].claimsModule;
          break;
        }
      }
      for (var con = 0; con < permisos.length; con++) {
        console.log(permisos[con].active);
        if (permisos[con].permiso == "Acceder" && permisos[con].active) {
          this.permisosProspectos.acceder = true;
        }
        if (permisos[con].permiso == "Detalles" && permisos[con].active) {
          this.permisosProspectos.detalles = true;
        }
        if (permisos[con].permiso == "Asignar" && permisos[con].active) {
          this.permisosProspectos.asignar = true;
        }
        if (permisos[con].permiso == "Aceptar" && permisos[con].active) {
          this.permisosProspectos.aceptar = true;
        }
        if (permisos[con].permiso == "Rechazar" && permisos[con].active) {
          this.permisosProspectos.rechazar = true;
        }
      }
      await this.verificarEntrada();
    },
    async verificarEntrada() {
      if (this.permisosProspectos.acceder) {
        await this.getItems();
      } else {
        this.$alert(this.$t("app.promps.permission_error"), "", {
          confirmButtonText: this.$t("app.buttons.accept"),
          callback: action => {
            this.$router.push({
              name: "Home"
            });
          }
        });
      }
    },
    changeDateApplic(value) {
      this.generalFilter();
    },
    changeDateAssi(value) {
      this.generalFilter();
    },
    generalFilter() {
      let result = this.tableData;
      // filter by search term
      if (this.searchQuery.length > 1) {
        result =
          this.searchQuery.length > 0
            ? result.filter(
                p =>
                  p.compañia
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase()) ||
                  p.nombreContacto
                    .toLowerCase()
                    .includes(this.searchQuery.toLowerCase())
              )
            : [];
      }
      if (this.dates_aplicat && this.dates_aplicat.length > 1) {
        if (result.length < 1) {
          result = this.tableData;
        }
        result =
          this.dates_aplicat[0] > new Date("1900-01-01") &&
          this.dates_aplicat[1] > new Date("1900-01-01") &&
          this.dates_aplicat[0] instanceof Date &&
          this.dates_aplicat[1] instanceof Date
            ? (result = result.filter(
                d =>
                  new Date(d.fechaEnvio) >= this.dates_aplicat[0] &&
                  new Date(d.fechaEnvio) <= this.dates_aplicat[1]
              ))
            : [];
      }
      if (this.dates_asign && this.dates_asign.length > 1) {
        if (result.length < 1) {
          result = this.tableData;
        }
        result =
          this.dates_asign[0] > new Date("1900-01-01") &&
          this.dates_asign[1] > new Date("1900-01-01") &&
          this.dates_asign[0] instanceof Date &&
          this.dates_asign[1] instanceof Date
            ? (result = result.filter(
                d =>
                  new Date(d.fechaAsignacion) >= this.dates_asign[0] &&
                  new Date(d.fechaAsignacion) <= this.dates_asign[1]
              ))
            : [];
      }
      this.searchedData = result;
    },
    parseDatetime(dt) {
      var year = dt.getFullYear();
      var month = (dt.getMonth() + 1).toString().padStart(2, "0");
      var day = dt
        .getDate()
        .toString()
        .padStart(2, "0");
      return year + "-" + month + "-" + day;
    },
    changeFilters(filters) {
      console.log(filters);
    },
    filterTag(value, row) {
      var other = row.nombre === value;
      // console.log(this.searchedData);
      // console.log(other);
      return other;
    },
    filterStatus(value, row) {
      var other = row.estadoProspecto === value;
      // console.log(this.searchedData);
      // console.log(other);
      return other;
    },
    asigned(value) {
      var response = false;
      if (value > 1) {
        response = true;
      }
      return response;
    },
    async getItems() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      var request = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario
      };
      await this.$http.post(route("Prospectos/getProspectos"), request).then(
        response => {
          if (response.body.code === 200) {
            this.tableData = response.body.prospectos;
            for (let item of this.tableData) {
              if (!this.asigned(item.prospectoStatus)) {
                item.nombre = this.$t("app.general.unassigned");
                item.fechaAsignacion = "";
              }
            }
            this.generalFilter();
          } else {
          }
        },
        error => {
          console.error(error);
        }
      );
      var payload = {
        id: 2,
        rol: "ventas"
      };
      await this.$http
        .post(route("Usuarios/getUsuariosByRol"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              for (let item of response.body.usuariosRol) {
                this.userFilters.push({
                  text: item.nombre,
                  value: item.nombre
                });
              }
              this.userFilters.push({
                text: this.$t("app.general.unassigned"),
                value: this.$t("app.general.unassigned")
              });
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
      this.$swal.close();
    },
    EditItem(index, row, ref) {
      this.$refs[ref].doClose();
      row.permisos = this.permisosProspectos;
      EventBus.$emit("prospectos-detalles", row);
    },
    AssignItem(index, row, ref) {
      this.$refs[ref].doClose();
      EventBus.$emit("prospectos-asignar", row);
    }
  }
};
</script>
